function randomInventoryNumber(min, max) {
  const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
  const mvistrElements = document.querySelectorAll('.mrandomInven');
  
  mvistrElements.forEach(element => {
    element.textContent = randomNum;
  });
}

function initMFCSwiper() {
  var swiper = new Swiper(".MFCSwiper", {
    freeMode: true,
    slidesPerView: 2.5,
    spaceBetween: 15,
    breakpoints: {
      768: { 
        slidesPerView: 4,
        spaceBetween: 25
      }
    },
    navigation: {
      nextEl: '.mfc-swiper-button-next',
      prevEl: '.mfc-swiper-button-prev',
      disabledClass: 'swiper-button-disabled' // This is the default class
    }
  });
}

const swiperMap = new Map();

function initCollectionTabsSwipers() {
  const screenWidth = window.innerWidth;
  const swiperElements = document.querySelectorAll('.MFCtabsSwiper');

  swiperElements.forEach(swiperEl => {
    const existingSwiper = swiperMap.get(swiperEl);

    if (screenWidth >= 768) {
      if (!existingSwiper) {
        const newSwiper = new Swiper(swiperEl, {
          freeMode: true,
          slidesPerView: 4,
          spaceBetween: 25,
          navigation: {
            nextEl: swiperEl.parentElement.querySelector('.mfc-swiper-button-next'),
            prevEl: swiperEl.parentElement.querySelector('.mfc-swiper-button-prev'),
            disabledClass: 'swiper-button-disabled'
          }
        });
        swiperMap.set(swiperEl, newSwiper);
      }
    } else {
      if (existingSwiper && typeof existingSwiper.destroy === 'function') {
        existingSwiper.destroy(true, true);
        swiperMap.delete(swiperEl);
      }
    }
  });

  const allSections = document.querySelectorAll('.m-collection-tabs-section');
  allSections.forEach(section => {
    const toggle1 = section.querySelector('.mcollection-toggle1');
    const toggle2 = section.querySelector('.mcollection-toggle2');
    const collection1 = section.querySelector('.mfeatured-collection1');
    const collection2 = section.querySelector('.mfeatured-collection2');

    if (toggle1 && toggle2 && collection1 && collection2) {
      toggle1.addEventListener('click', () => {
        collection1.classList.remove('mcollection-hide');
        collection2.classList.add('mcollection-hide');
        toggle1.classList.add('mactive');
        toggle2.classList.remove('mactive');
      });

      toggle2.addEventListener('click', () => {
        collection1.classList.add('mcollection-hide');
        collection2.classList.remove('mcollection-hide');
        toggle1.classList.remove('mactive');
        toggle2.classList.add('mactive');
      });
    }
  });
}

window.addEventListener('resize', initCollectionTabsSwipers);





function updateShippingDate() {
  let dateMonth = document.getElementById('mshippingDate');
  if (dateMonth) {
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const now = new Date();
    const tomorrow = new Date(now);
    
    // Check if tomorrow is Sunday, if so skip to Monday
    let dayToAdd = 1;
    if (tomorrow.getDay() === 6) { // If today is Saturday, tomorrow is Sunday
      dayToAdd = 2;
    }
    tomorrow.setDate(now.getDate() + dayToAdd);

    const formattedDate = `${daysOfWeek[tomorrow.getDay()]}, ${tomorrow.getDate()} ${months[tomorrow.getMonth()]}`;
    dateMonth.innerText = formattedDate;

    const msUntilMidnight = new Date(now.setHours(24, 0, 0, 0)) - now;
    setTimeout(() => {
      updateShippingDate();
      setInterval(updateShippingDate, 24 * 60 * 60 * 1000);
    }, msUntilMidnight);
  }
}



initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});
$(document).on('shopify:section:unload', function(event) {
   initslide();
});
function initslide() {
    $('.M-testim-slider').slick({
    infinite: true,
    speed: 400,
    autoplay: true,
    slidesToShow: 3,
    pauseOnHover: false,
    slidesToScroll: 3,
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    adaptiveHeight: true,
    autoplaySpeed: 5000,
    dots: true,
    responsive: [ 
      {
        breakpoint: 991,
        settings: {
         centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },      
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      }
    ]
  });
}